import React from 'react'

const CompanyStaff = ({member}) => {
  const {name, email, password} = member;
  return (
    <div>
        <h1>
          {name}
        </h1>
    </div>
  )
}

export default CompanyStaff